import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var TabBar = function TabBar(_a) {
  var _b = _a.borderBottom,
    borderBottom = _b === void 0 ? false : _b,
    children = _a.children;
  var className = classNames(["overflow-x-auto", "auto-qa-tab-bar"], borderBottom && ["border-b", "border-muted"]);
  return /*#__PURE__*/React.createElement("ul", {
    className: className
  }, children);
};
TabBar.propTypes = {
  borderBottom: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export { TabBar };
//# sourceMappingURL=index.es.js.map
